export interface Module {
  num: string
  title: string
  description: string
}

export const modules: Module[] = [
  {
    num: '1',
    title: 'Fondamentaux de la Domotique™',
    description:
      'Comprenez réellement comment fonctionne une maison connectée. Découvrez capteurs, actionneurs, relais, hubs, passerelles et contrôleurs ainsi que Wi-Fi, Bluetooth, Zigbee, Z-Wave, Thread et Matter. Apprenez les bases du réseau, de l’interopérabilité, du fonctionnement local et cloud et les notions électriques indispensables pour commencer à raisonner comme un véritable concepteur de système domotique.',
  },
  {
    num: '2',
    title: 'Conception & Planification™',
    description:
      'Transformez une habitation en projet domotique organisé. Analysez chaque pièce, identifiez les besoins, définissez les fonctions, sélectionnez protocoles et appareils, évaluez la couverture réseau et planifiez éclairage, chauffage, volets roulants, sécurité, énergie et automatisations. Passez d’une simple idée à un véritable dossier de conception avant de commencer l’installation.',
  },
  {
    num: '3',
    title: 'Installation & Mise en Service™',
    description:
      'Transformez votre conception en système fonctionnel. Apprenez à mettre en service hubs, passerelles, capteurs, éclairage, prises connectées, thermostats, volets et autres équipements compatibles. Vérifiez appairage, connexion, couverture, firmware et réponse de chaque appareil grâce à une procédure structurée permettant d’identifier les problèmes avant de poursuivre.',
  },
  {
    num: '4',
    title: 'Automatisations & Scénarios™',
    description:
      'Allez au-delà du simple contrôle depuis une application et créez une maison qui réagit automatiquement. Travaillez avec déclencheurs, conditions et actions pour automatiser éclairage, chauffage, volets, sécurité, présence, confort et consommation énergétique. Progressez des automatisations simples jusqu’aux scénarios matin, départ, retour, nuit et vacances.',
  },
  {
    num: '5',
    title: 'Intégration & Systèmes Avancés™',
    description:
      'Apprenez à réunir plusieurs technologies dans un système centralisé. Découvrez comment Home Assistant, Jeedom, Zigbee, Matter, Thread et les appareils Wi-Fi peuvent cohabiter dans une installation structurée. Travaillez sur tableaux de bord, accès distant, fonctionnement local, utilisateurs, sauvegardes, mises à jour, sécurité et résolution des problèmes d’intégration.',
  },
  {
    num: '6',
    title: 'Projets Complets & Méthode Professionnelle™',
    description:
      'Mettez toutes vos compétences en pratique grâce à des projets progressifs et réalistes. Studio connecté, appartement intelligent, maison complète et projet client simulé : suivez chaque réalisation depuis l’analyse des besoins jusqu’à la sélection des équipements, l’installation, la configuration, les automatisations, les tests, le dépannage et la documentation finale.',
  },
]

export const promises = [
  'Apprendre dans un ordre logique.',
  'Comprendre appareils et protocoles.',
  'Concevoir avant d’installer.',
  'Installer et configurer vos systèmes.',
  'Créer des automatisations réellement utiles.',
  'Intégrer différents appareils et écosystèmes.',
  'Passer de la théorie à des projets pratiques.',
]
